export default "assets/images/flags/es-3ba5ce15.svg";